import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../../images/location_new/fold11/Toronto.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol for Your Mobile App Solutions in Toronto?
            </h2>
            <p>
              You can surely consider TekRevol's mobile app development
              expertise in Toronto, Canada where you get tailor-made solutions
              using the latest technologies crafted for your success. We have
              consistently delivered exceptional mobile apps that have earned
              recognition in the industry and achieved remarkable success.
            </p>
            <p>
              Our mobile app development company in Toronto Has cultivated a
              culture of transparency and clear communication, ensuring you are
              well informed at every stage of the development process. Your
              satisfaction remains our utmost priority, and we consistently go
              the extra mile to exceed your expectations, forging lasting
              partnerships.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="App development in Toronto"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
